module.exports = __webpack_public_path__ + "static/media/post-signup-info.6e57ce57.svg";